// Feeds the app/auth subtree with the locale from the locale store
// (preference-driven), as opposed to the marketing pages which set their
// locale per route from the URL. Rendered once near the root; marketing
// routes nest their own LocaleProvider, which overrides this.

import type { ReactNode } from "react";

import { LocaleProvider } from "@/i18n/LocaleProvider";
import { useLocaleStore } from "@/stores/localeStore";

export function AppLocaleProvider({ children }: { children: ReactNode }) {
  const locale = useLocaleStore((s) => s.locale);
  return <LocaleProvider locale={locale}>{children}</LocaleProvider>;
}
